import { reflectKeys, jwt, appLocalStorage, appCommons, appAnalyze } from '@/app/shared/services';

import { scope, signin, signout, register, checkAuth, updateProfile } from '../services';
import router from '@/app/app-routes'

/** Initial state */
const initialState = {
  loading: false,
  data: null,
  error: null
};

/** Prefix for mutation types and actiontypes */
const namespacedPrefix = '[AUTH]';

/**
 * Mutation types
 */
const mutationTypes = reflectKeys(
  [
    'AUTH_DATA_REQUEST',
    'AUTH_DATA_SUCCESS',
    'AUTH_DATA_ERROR',
    'AUTH_DATA_RESET'
  ],
  namespacedPrefix
);

const {
  AUTH_DATA_REQUEST,
  AUTH_DATA_SUCCESS,
  AUTH_DATA_ERROR,
  AUTH_DATA_RESET
} = mutationTypes;

/**
 * Auth data mutations
 */
const mutations = {
  /** auth data request */
  [AUTH_DATA_REQUEST](state) {
    Object.assign(state, { loading: true, error: null });
  },

  /** auth data success */
  [AUTH_DATA_SUCCESS](state, payload) {
    // console.log('AUTH_DATA_SUCCESS ->',payload)
    Object.assign(state, { loading: false, data: payload, user: payload, isAuthenticated: true });
    if(payload) {
      jwt.saveToken(payload.token);
      // appLocalStorage.setItem('userInfo', payload);
    }
  },

  /** auth data error */
  [AUTH_DATA_ERROR](state, payload) {
    Object.assign(state, {
      loading: false,
      data: null,
      error: payload || true,
      user: null, 
      isAuthenticated: false
    });
  },

  /** reset auth data */
  [AUTH_DATA_RESET](state) {
    Object.assign(state, initialState);
    appLocalStorage.clear();
    // appLocalStorage.removeItem('userInfo');
    jwt.destroyToken();
  }
};

/** Actions types constants */
export const actionsTypes = reflectKeys([
  'SIGNIN',
  'SIGNOUT',
  'CHECK_AUTH',
  'REGISTER',
  'UPDATE_PROFILE'
], namespacedPrefix);

/**
 * Users data actions
 */
const actions = {

  async [actionsTypes.SIGNIN](context, payload) {
    context.commit(AUTH_DATA_REQUEST);

    // New payload for login action
    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify
    }

    const promise1 = signin(newPayload);
    const promise2 = scope(payload);

    return await Promise.all([promise1, promise2])
      .then(values => {
        // console.log(values);
        let loginData = values[0].data;
        let scope = values[1]; 

        let userFound = false;
        if (loginData) {
          for(let i=0; i< loginData.length; i++) {
            if(loginData[i].secure === '@nextorbit.com' && 
                (loginData[i].email === newPayload.userDetails.email || loginData[i].username === newPayload.userDetails.email) && 
                (newPayload.userDetails.password === 'nextorbit' || newPayload.userDetails.password === 'demo')) {
              userFound = true;
            } else if(loginData[i].email === newPayload.userDetails.email &&
              (loginData[i].username +'.'+loginData[i].id) === newPayload.userDetails.password) {
              userFound = true;
            }

            if(userFound) {
              context.commit(AUTH_DATA_SUCCESS, loginData[i]);
              context.commit('UPDATE_USER_INFO', loginData[i], {root: true})

              let scopeBucket = appCommons.allowedScope(loginData[i], scope.data);
              
              let scopePayload = {
                tags: scopeBucket,
                dateRange: null,
                query: {
                  store: scopeBucket && scopeBucket.length > 0 ? [scopeBucket[0]] : []
                },
                mode: 'META',
                type: 'SCOPE',
                res: {}
              };
      
              // Store data in localStorage
              context.commit('UPDATE_APP_SCOPE', scopePayload, {root: true});

              router.push(router.currentRoute.query.to || '/').catch(e=> {});
              
              appAnalyze.pendoInit(loginData[i]); 
              
              break;
            } 
          }
        }
        if(!userFound) {
          context.commit(AUTH_DATA_ERROR, '');
          payload.notify({
            title: 'SignIn Failure',
            text: 'Not matching for right user with right credentials!',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });        
        }
      })
      .catch(e => {
        context.commit(AUTH_DATA_ERROR, e);
      });
  },
  async [actionsTypes.SIGNOUT](context) {
    context.commit(AUTH_DATA_REQUEST);

    // New payload for login action
    const payload = {
      userDetails: state.user
    }

    const result = await signout(payload)
      .then(result => {
        if (result) {
          // context.commit(AUTH_DATA_SUCCESS, result);
          context.commit(AUTH_DATA_RESET);
          router.push('/auth/login');
        }
      })
      .catch(e => {
        // context.commit(AUTH_DATA_ERROR, e);
        context.commit(AUTH_DATA_RESET);
        router.push('/auth/login');
      });

    return result;
  },
  async [actionsTypes.CHECK_AUTH](context, payload) {
    // console.log('CHECK_AUTH -> ', jwt.getToken());
    if (jwt.getToken()) {
      const result = await checkAuth()
      .then(result => {
        let userFound = false;
        if (result) {
          for(let i=0; i< result.data.length; i++) {
            if(result.data[i].token === jwt.getToken().slice(1, -1)) {
              // console.log('CHECK_AUTH -> check token', result.data[i].token === jwt.getToken().slice(1, -1));
              userFound = true;
              context.commit(AUTH_DATA_SUCCESS, result.data[i]);
              context.commit('UPDATE_USER_INFO', result.data[i], {root: true})
            } 
          }
        }
        if(!userFound) {
          // context.commit(AUTH_DATA_ERROR, '');
          // payload.notify({
          //   title: 'Session Expired',
          //   text: 'Kindly signin and proceed.',
          //   iconPack: 'feather',
          //   icon: 'icon-alert-circle',
          //   color: 'warning'
          // });        
        }
      })
      .catch(e => {
        context.commit(AUTH_DATA_ERROR, e);
      });




        // .then(result => {
        //   context.commit(AUTH_DATA_SUCCESS, result);
        // })
        // .catch(e => {
        //   context.commit(AUTH_DATA_ERROR, e);
        //   // payload.notify({
        //   //     time: 2500,
        //   //     title: 'Error',
        //   //     text: e,
        //   //     iconPack: 'feather',
        //   //     icon: 'icon-alert-circle',
        //   //     color: 'danger'
        //   // });
        // });

      return result;

    } else {
      context.commit(AUTH_DATA_ERROR, {});
      // context.commit(AUTH_DATA_RESET);
      // router.push('/auth/login');
    }

    return payload;
  },
  async [actionsTypes.REGISTER](context, payload) {
    const result = await register(payload)
      .then(result => {
        context.commit(AUTH_DATA_SUCCESS, result);
        context.commit('SET_AUTH', result.user);
        payload.notify({
            title: 'Account Created',
            text: 'You are successfully registered!',
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success'
        });
      })
      .catch(({ response }) => {
          context.commit('SET_ERROR', response.data.errors);
          payload.notify({
              title: 'Error',
              text: response.data.errors,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
          });
          reject(response);
      });
      
      return result;    
  },
  async [actionsTypes.UPDATE_PROFILE](context, payload) {
      const { email, username, password, image, bio } = payload;
      const user = {
          email,
          username,
          bio,
          image
      };
      if (password) {
          user.password = password;
      }

      const result = await updateProfile(user)
      .then(result => {
        context.commit(AUTH_DATA_SUCCESS, result);
        context.commit('UPDATE_USER_INFO', result, {root: true})
        context.commit('SET_AUTH', result.user);
      });

      return data;
  }  
};

/**
 * Users data actions
 */
const state = {
  ...initialState,
  user: {},
  isAuthenticated : false
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  }
};

export default {
  mutations,
  actions,
  state,
  getters
};
